import request from '@/utils/request'


// 查询实名认证列表
export function listAuthentication(query) {
  return request({
    url: '/authentication/authentication/list',
    method: 'get',
    params: query
  })
}

// 查询实名认证分页
export function pageAuthentication(query) {
  return request({
    url: '/authentication/authentication/page',
    method: 'get',
    params: query
  })
}

// 查询实名认证详细
export function getAuthentication(data) {
  return request({
    url: '/authentication/authentication/detail',
    method: 'get',
    params: data
  })
}

// 新增实名认证
export function addAuthentication(data) {
  return request({
    url: '/authentication/authentication/add',
    method: 'post',
    data: data
  })
}

// 修改实名认证
export function updateAuthentication(data) {
  return request({
    url: '/authentication/authentication/review',
    method: 'post',
    data: data
  })
}

// 删除实名认证
export function delAuthentication(data) {
  return request({
    url: '/authentication/authentication/delete',
    method: 'post',
    data: data
  })
}
